import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setTokens, clearTokens, getAccess } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = async () => {
    if (!getAccess()) { setUser(null); setLoading(false); return; }
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
    } catch {
      setUser(null);
      clearTokens();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadMe(); }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    setTokens(res.data.access_token, res.data.refresh_token);
    await loadMe();
  };

  const register = async (payload) => {
    const res = await api.post("/auth/register", payload);
    setTokens(res.data.access_token, res.data.refresh_token);
    await loadMe();
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    clearTokens();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshMe: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
